import { createSurveyStyles } from '@sm/webassets';
import { WrenchTheme } from '@wds/styles';

type StyleNames = 'progressBarContainer' | 'progressBar' | 'textRight' | 'textLeft';
type StyleProps = {
  isRTL: boolean;
};

const useStyles = createSurveyStyles<StyleNames, StyleProps>(theme => {
  return {
    progressBarContainer: {
      height: 24,
      background: theme.primaryAccentColor ?? {},
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 'auto',
      width: '50%',
      borderRadius: 12,
      direction: ({ isRTL }: StyleProps) => (isRTL ? 'rtl' : null),
      [`@media only screen and (max-width: ${theme.breakpoints?.sm.max})`]: {
        width: '75%',
      },
      [`@media only screen and (max-width: ${theme.breakpoints?.xs.max})`]: {
        width: '100%',
      },
    },
    progressBar: {
      width: '100%',
      marginLeft: 12,
      marginRight: 12,
    },
    textLeft: {
      fontFamily: WrenchTheme.type.fontFamily.base,
      color: theme.secondaryAccentColor ?? {},
      fontSize: 13,
      margin: ({ isRTL }: StyleProps) => (isRTL ? '0 24px 0 0' : '0 0 0 24px'),
    },
    textRight: {
      fontFamily: WrenchTheme.type.fontFamily.base,
      color: theme.secondaryAccentColor ?? {},
      fontSize: 13,
      margin: ({ isRTL }: StyleProps) => (isRTL ? '0 0 0 24px' : '0 24px 0 0'),
    },
  };
});

export default useStyles;
